import { gql } from '@apollo/client'

const RESEND_CONFIRMATION_EMAIL = gql`
  mutation ResendConfirmationEmail($storeOrderId: [String]) {
    resendConfirmationEmail(storeOrderId: $storeOrderId) {
      id
    }
  }
`

export default RESEND_CONFIRMATION_EMAIL
